// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/assets/" + (chunkId === "8971" ? "monaco" : chunkId) + "." + {"1052": "a2a8c73d","3648": "a6db9191","3959": "d32ac3c7","4775": "2d13de22","5287": "f845d943","5764": "b64005ac","7081": "bad68cbc","7599": "fd4e9e6c","8078": "b7ed5f4a","8429": "6af4ba81","8922": "6a0fbe6a","8971": "906d79fe",}[chunkId] + ".css"
}